var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBiddingInfoorg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 101,
    viewBox: "0 0 116 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116 48L115 47C113.575 45.6416 111.832 45 110 45H101C101.136 46.6301 101 48.234 101 50C101 51.766 101.136 54.302 101 56H107C111.884 56 116 60.2266 116 66V69L115 68C113.575 66.7095 111.832 66 110 66H99C93.7766 88.8897 75.7626 101 47 101H10C10 101 15 96.9731 15 84V66H9C4.04796 66 0 60.7054 0 55V53L1 54C2.35672 55.2905 4.16842 56 6 56H15V45H9C4.04796 45 0 40.7054 0 35V32L1 33C2.35672 34.2905 4.16842 35 6 35H15V18C15 4.61937 10 0 10 0H47C74.9485 0 93.5053 11.9744 99 35H107C111.884 35 116 40.2266 116 46V48ZM46 5H30V35H82C78.4725 13.9442 66.8257 5 46 5ZM83 50C83 48.234 83.0678 46.6301 83 45H30V56H83C83.0678 54.302 83 51.766 83 50ZM30 96H46C68.0468 95.4566 78.676 85.0861 82 66H30V96Z",
    fill: "#E95923"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiddingInfoorg);
export default __webpack_public_path__ + "static/media/Bidding Info org.e9152309eda610b702319711594ebaab.svg";
export { ForwardRef as ReactComponent };